import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/nuxt/layouts/default.vue").then(m => m.default || m)),
  newsletter: defineAsyncComponent(() => import("/workspace/nuxt/layouts/newsletter.vue").then(m => m.default || m))
}